import React from 'react'
import { FormattedMessage } from 'react-intl'
import CommandBarProvider, { useCommandBar } from 'contexts/command-bar'
import {
    FromBreakpoint, BelowBreakpoint,
    DragGuidelines, Guideline,
    Button, Shortcut
} from './s'
import Modal from './modal'
import { Search } from 'styled-icons/feather'

const salt = 'command-bar'

const CommandBar = () => {
    const {
        // Modal
        setShow,

        // Drag & Snap
        isDragging
    } = useCommandBar()

    return (
        <>
            <FromBreakpoint>
                <Button
                    icon={Search}
                    onClick={() => setShow(true)}>
                    <span>
                        <FormattedMessage
                            id="command_bar_search_label"
                            defaultMessage="Quick search" />
                    </span>
                    <Shortcut
                        shortcut={[
                            'mod',
                            'k'
                        ]}
                        className="fill"
                        salt="command-bar" />
                </Button>
            </FromBreakpoint>
            <BelowBreakpoint>
                <Button
                    icon={Search}
                    onClick={() => setShow(true)} />
            </BelowBreakpoint>
            <DragGuidelines {...(!!isDragging ? { className: 'show' } : null)}>
                <Guideline className="top" />
                <Guideline className="left" />
                <Guideline className="right" />
            </DragGuidelines>
            <Modal salt={salt} />
        </>
    )
}

export default props => (
    <CommandBarProvider>
        <CommandBar {...props} />
    </CommandBarProvider>
)